import {h, Component} from 'preact'
import {HomepageElement, Container21HomepageElement, GenericHomepageElementTypes} from '../homepage'
import WidgetColumn from './widget-column'
import { widgetsToAddSidebar, widgetsToAddMainContent } from './new-button'
import globals from '../../utils/globals'

interface Props {
  parentEl: HTMLElement,
  homepageElement: Container21HomepageElement,
  onChildEnter: () => void,
  onChildLeave: () => void,
  onChange: (change: ElementChange) => void,
  controlUrl: string,
  currentPage: 'homepage' | 'ideation'
}

interface State {
  editingId: string | null,
  column_1: Container21HomepageElement['config']['column_1'],
  column_2: Container21HomepageElement['config']['column_2'],
}

const assignIds = (el: HomepageElement, idx: number) => Object.assign({}, el, {id: idx})


export type ElementChange = Pick<HomepageElement, 'type' | 'config' | 'title'>

export type DonePayload = {idx: number, element: ElementChange}
export type MovePayload = {direction: 'up' | 'down'}
export type VisiblePayload = boolean

export default class ContainerEditor extends Component<Props, State> {
  constructor(props: Props) {
    super()

    this.state = {
      editingId: null,
      column_1: props.homepageElement.config.column_1.map(assignIds),
      column_2: props.homepageElement.config.column_2.map(assignIds),
    }
    this.fireOnChange= this.fireOnChange.bind(this)
    this.getHomepageSidebarWidgetList = this.getHomepageSidebarWidgetList.bind(this)
    this.getIdeationSidebarWidgetList = this.getIdeationSidebarWidgetList.bind(this)
    this.getHomepageMainWidgetList = this.getHomepageMainWidgetList.bind(this)
    this.getIdeationMainWidgetList = this.getIdeationMainWidgetList.bind(this)
  }

  fireOnChange() {
    this.props.onChange({
      type: 'container_2_1',
      config: {
        column_1: this.state.column_1,
        column_2: this.state.column_2,
      }
    })
  }

  getHomepageSidebarWidgetList () {
    let sideBarWidgetList: Array<widgetsToAddSidebar> = [{
      type: 'leaderboard_points',
      title: 'Leaderboard',
      description: 'A list of users that gain the most points'
    }, {
      type: 'event_calendar',
      title: 'Events Calendar',
      description: 'A list of all upcoming events'
    }, {
      type: 'html_widget',
      title: 'HTML widget',
      description: 'Custom widget by HTML'
    }, {
      type: 'badges',
      title: 'Awarded Badges widget',
      description: 'A list of users that recently received a badge'
    }, {
      type: GenericHomepageElementTypes.announcement_card,
      title: 'Announcement card',
      description: 'One topic featured by moderator tag \'featured_side\''
    }, {
      type: 'tag_cloud',
      title: 'Tag cloud',
      description: 'A cloud of your most used tags'
    }, {
      type: 'solved_topics',
      title: 'Solved Topics',
      description: 'A list of topics with a best answer assigned'
    }, {
      type: 'most_liked',
      title: 'Most liked',
      description: 'A list of users that received the most likes'
    }, {
      type: 'community_statistics',
      title: 'Community Statistics',
      description: 'Shows community wide statistics'
    }]

    const isEventModuleEnabled = ((globals('activeModules') || []).indexOf('event') !== -1)
    if (!isEventModuleEnabled) {
      const eventsCalendarWidget = sideBarWidgetList.findIndex(element => element.type === 'event_calendar')
      sideBarWidgetList.splice(eventsCalendarWidget, 1)
    }
    const isPointSystemModuleEnabled = ((globals('activeModules') || []).indexOf('pointSystem') !== -1)
    if (!isPointSystemModuleEnabled) {
      const leaderboardPointsWidget = sideBarWidgetList.findIndex(element => element.type === 'leaderboard_points')
      sideBarWidgetList.splice(leaderboardPointsWidget, 1)
    }

    return sideBarWidgetList
  }

  getIdeationSidebarWidgetList (): Array<widgetsToAddSidebar> {
    return [
      {
        type: GenericHomepageElementTypes.announcement_card,
        title: 'Announcement card',
        description: 'One topic featured by moderator tag \'featured_side\''
      },
      {
        type: 'html_widget',
        title: 'HTML widget',
        description: 'Custom widget by HTML'
      },
      {
        type: 'tag_cloud',
        title: 'Tag cloud',
        description: 'A cloud of your most used tags'
      }
     ]
  }

  getHomepageMainWidgetList (): Array<widgetsToAddMainContent> {
    return [{
      type: 'html_widget',
      title: 'HTML widget',
      description: 'Custom widget by HTML'
    }, {
      type: 'knowledge_base',
      title: 'Knowledge Base',
      description: 'Navigation cards to knowledge base parent categories'
    }, {
      type: 'community_category',
      title: 'Community Category',
      description: 'Navigation cards to community parent categories'
    }, {
      type: 'category_and_topics_stream_only',
      title: 'Tabs',
      description: 'Browse community categories and topics'
    }]
  }

  getIdeationMainWidgetList (): Array<widgetsToAddMainContent> {
    return [{
      type: 'html_widget',
      title: 'HTML widget',
      description: 'Custom widget by HTML'
    }]
  }

  render({ homepageElement, controlUrl, currentPage }: Props, {column_1, column_2}: State) {
    const sideBarWidgetList: Array<widgetsToAddSidebar> = currentPage === 'homepage' ? this.getHomepageSidebarWidgetList() : this.getIdeationSidebarWidgetList()
    const mainWidgetList: Array<widgetsToAddMainContent> = currentPage === 'homepage' ? this.getHomepageMainWidgetList() : this.getIdeationMainWidgetList()

    return <div>
      <WidgetColumn
        container={`.widget-container--index-${homepageElement.id} .widget-container--container-2-1-column_1`}
        classPrefix='widget-container--container-2-1-column_1-index-'
        elements={column_1}
        controlUrl={controlUrl}
        widgetList={mainWidgetList}
        onChange={(column_1: Container21HomepageElement['config']['column_1']) => this.setState({column_1}, this.fireOnChange)}
        onChildMouseOut={this.props.onChildLeave}
        onChildMouseOver={this.props.onChildEnter}
        currentPage={currentPage}
        nested
      />

      <WidgetColumn
        container={`.widget-container--index-${homepageElement.id} .widget-container--container-2-1-column_2`}
        controlUrl={controlUrl}
        widgetList={sideBarWidgetList}
        classPrefix='widget-container--container-2-1-column_2-index-'
        elements={column_2}
        onChange={(column_2: Container21HomepageElement['config']['column_2']) => this.setState({column_2}, this.fireOnChange)}
        onChildMouseOut={this.props.onChildLeave}
        onChildMouseOver={this.props.onChildEnter}
        currentPage={currentPage}
        nested
      />
    </div>
  }
}
